<template>
  <div class="pe-form">
    <p class="t-note m-b-5">
      参考值为系统按照中英、英中项目统计计算的，请根据自己项目实际情况填写。
    </p>
    <div style="display: flex">
      <el-form
        :model="childConfigInfo"
        :rules="rules"
        ref="childConfigInfo"
        label-width="180px"
        class="demo-ruleForm"
        v-loading="loading"
      >
        <p class="p1">
          {{ flowLevel == 3 ? 'PE' : flowLevel == 4 ? '审核' : 'PE' }}设置
          <span>此设置任务已配置不可修改</span>
        </p>
        <el-form-item
          :rules="{ required: true, message: '任务截止时间不能为空' }"
          label="任务截止时间"
          prop="limitTime"
          class="m-t-20"
        >
          <el-date-picker
            v-model="childConfigInfo.limitTime"
            :disabled="childConfigInfo.isConfigDisabled"
            type="datetime"
            format="yyyy-MM-dd HH:mm"
            valueFormat="timestamp"
            @change="changeTime"
            :pickerOptions="this.pickerOptions"
            placeholder="选择任务截止时间"
          ></el-date-picker>
          <p class="input-note">
            （任务截止时间前请勿结束任务，否则可能产生译员译费损失而导致的投诉）
          </p>
        </el-form-item>
        <el-form-item
          label="PE价格"
          prop="pePrice"
          v-if="flowLevel == 3 || flowLevel == 5"
        >
          <el-input-number
            :controls="false"
            v-model="childConfigInfo.pePrice"
            :precision="2"
            :min="minPeLimit"
            :max="100000"
            :disabled="childConfigInfo.isConfigDisabled"
            placeholder="请输入PE价格"
          ></el-input-number>
          <span class="input-company">元/千字</span>
          <p class="input-note" v-if="!childConfigInfo.isConfigDisabled">
            推荐价格：{{ this.markingRecommend.recommendPePrice }}元/千字
          </p>
        </el-form-item>
        <hr v-if="flowLevel == 5" />
        <p class="p1">
          &nbsp;
          <span>&nbsp;</span>
        </p>
        <p class="p1" v-if="flowLevel == 5">
          审核设置
          <span>此设置任务进行中不可修改</span>
        </p>
        <el-form-item
          label="PE审核价格"
          prop="peAuditPrice"
          v-if="flowLevel == 4 || flowLevel == 5"
        >
          <el-input-number
            :disabled="childConfigInfo.isConfigDisabled"
            :controls="false"
            v-model="childConfigInfo.peAuditPrice"
            :precision="2"
            :min="minPeAuditLimit"
            :max="100000"
            placeholder="请输入PE审核价格"
          ></el-input-number>
          <span class="input-company">元/千字</span>
          <p class="input-note" v-if="!childConfigInfo.isConfigDisabled">
            平台平均价格：{{ markingRecommend.recommendPeAuditPrice }}元/千字
          </p>
        </el-form-item>
        <hr />
        <p class="p1 m-b-5">
          规则配置
          <span>此设置任务进行中可以修改</span>
        </p>
        <el-form-item label="任务规则" prop="remark">
          <el-input
            :disabled="childConfigInfo.isRemarkDisabled"
            type="textarea"
            :maxlength="1000"
            show-word-limit
            rows="6"
            resize="none"
            v-model="childConfigInfo.remark"
            style="width: 420px"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="
              !childConfigInfo.isConfigDisabled && permissions.dot_flow_start
            "
            size="medium"
            type="primary"
            @click="submitForm('childConfigInfo')"
          >
            开始PE
          </el-button>
          <el-button
            v-if="
              childConfigInfo.isConfigDisabled &&
              !childConfigInfo.isRemarkDisabled &&
              permissions.dot_flow_start
            "
            size="medium"
            type="primary"
            @click="saveRemark('childConfigInfo')"
          >
            保存
          </el-button>
        </el-form-item>
      </el-form>
      <el-card class="box-card bg-white p-l-15">
        <div class="text item t-c f-s-30 m-b-5">公告</div>
        <div class="l-h-26">
          DOT属于大规模协同工作，任务一旦开始无法中断，请各位PM确认开始任务之前务必在订单详情中检查机翻稿是否存在以下问题：
        </div>
        <div class="l-h-26">1、存在因为排版原因造成的断句偏差很大</div>
        <div class="l-h-26">
          2、存在因为解析问题，如造成原文中特殊符号、单位等偏差很大
        </div>
        <div class="l-h-26">3、存在术语加持失败，造成译文质量很差</div>
        <div class="l-h-26">4、存在机翻译文有遗漏</div>
        <div class="l-h-26">
          如存在以上任一问题，建议暂停轻任务配置，联系相关人员分析处理；
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { peStart, getRecommendTime } from '@/api/dot/pe';
import { recommend } from '@/api/dot/order';
import { saveRemark, statistics } from '@/api/dot/flow';
import { formatDate } from '@/util/date';
import { mapGetters } from 'vuex';
import { alertErroMsg, alertSuccessMsg, alertCommon } from '@/util/commonMsg';

export default {
  props: [
    'flowLevel',
    'configInfo',
    'orderId',
    'slan',
    'tlan',
    'staParams',
    'orderTag',
    'pePrice',
  ],
  data() {
    var validatePePrice = (rule, value, callback) => {
      if (this.slan === 'zh-CN' && this.tlan === 'en' && value < 9) {
        return callback(new Error('下限最少是9'));
      } else if (this.tlan === 'zh-CN' && this.slan === 'en' && value < 12) {
        return callback(new Error('下限最少是12'));
      } else {
        callback();
      }
    };
    var validatePeAuditPrice = (rule, value, callback) => {
      if (this.slan === 'zh-CN' && this.tlan === 'en' && value < 11) {
        return callback(new Error('下限最少是11'));
      } else if (this.tlan === 'zh-CN' && this.slan === 'en' && value < 15) {
        return callback(new Error('下限最少是15'));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      tempRecommend: 1,
      markingRecommend: {},
      hasLoad: false,
      childConfigInfo: this.configInfo,
      childOrderId: this.orderId,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      rules: {
        pePrice: [
          { required: true, message: '请输入价格', trigger: 'blur' },
          // {validator: validatePePrice, trigger: 'blur'}
        ],
        peAuditPrice: [
          { required: true, message: '请输入PE审核价格', trigger: 'blur' },
          // {validator: validatePeAuditPrice, trigger: 'blur'}
        ],
        remark: [
          { required: true, message: '请填写任务规则', trigger: 'blur' },
        ],
      },
    };
  },

  watch: {
    configInfo: function (n, o) {
      this.childConfigInfo = n;
    },
    'childConfigInfo.limitTime': function (n, o) {
      if (n == null) {
        this.markingRecommend.recommendModifyLimitTime = this.tempRecommend;
      } else {
        let diff = (n - Date.now()) / 1000 / 60 / 60;
        if (diff <= 4) {
          this.markingRecommend.recommendModifyLimitTime = 0.5;
        } else if (diff <= 8) {
          this.markingRecommend.recommendModifyLimitTime = 1;
        } else {
          this.markingRecommend.recommendModifyLimitTime = 2;
        }
      }
    },
  },
  updated() {
    if (this.childConfigInfo.status === 1 && !this.hasLoad) {
      this.hasLoad = true;
      recommend(this.childConfigInfo.orderId, 2).then((res) => {
        this.markingRecommend = res.data.data;
        this.tempRecommend = this.markingRecommend.recommendModifyLimitTime;
      });
    }
  },

  mounted() {
    this.childConfigInfo.pePrice = this.pePrice;
  },

  methods: {
    // 修改时间获取最新价格
    changeTime() {
      recommend(
        this.childConfigInfo.orderId,
        2,
        this.childConfigInfo.limitTime,
      ).then((res) => {
        this.markingRecommend = res.data.data;
        this.tempRecommend = this.markingRecommend.recommendModifyLimitTime;
      });
    },

    // 跳转到留言页面
    gotoMessage() {
      const routeLink = this.$router.resolve({
        path: '/projectRule',
      });
      window.open(routeLink.href, '_blank');
    },

    peStart(form, isRisk) {
      let curTime = new Date();
      let addHours = curTime.setHours(curTime.getHours() + 8);
      let dateAfter8 = new Date(addHours);
      if (this.$refs[form].model.limitTime < Date.now()) {
        this.$message.error('不可选择过去时间');
        this.loading = false;
        return;
      }

      /* if (this.$refs[form].model.limitTime < dateAfter8) {
        this.$message.error("项目截止时间小于规定时间");
        this.loading = false
        return;
      } */

      this.loading = true;
      peStart(
        Object.assign(
          this.$refs[form].model,
          {
            flowId: this.$route.params.id,
            orderId: this.orderId,
            isRisk: isRisk,
          },
          {
            recommendPePrice:
              this.flowLevel == 3 || this.flowLevel == 5
                ? this.markingRecommend.recommendPePrice
                : '',
            recommendPeAuditPrice:
              this.flowLevel == 4 || this.flowLevel == 5
                ? this.markingRecommend.recommendPeAuditPrice
                : '',
            recommendLimitTime: this.markingRecommend.recommendLimitTime,
          },
        ),
      ).then((response) => {
        //配置成功
        if (response.data.data === 2) {
          this.$alert(
            `您的项目还有质控任务，PE任务与质控任务同时进行，请前往配置质控任务`,
            {
              confirmButtonText: '确定',
              callback: (action) => {
                if (action === 'confirm') {
                  this.$router.replace('/refresh');
                } else {
                  this.$router.replace('/refresh');
                }
              },
            },
          );
        } else {
          alertCommon(response.data.data, '提交成功', '配置PE失败');
        }
        statistics(
          Object.assign(
            {
              event_name: '开始PE',
              event_type: 'click',
              class_name: 'peStart',
              class_url: '/dotadmin/dotadmin/pe/start/',
            },
            this.staParams,
          ),
        );
      });
    },

    saveRemark(form) {
      console.log(this.$refs[form].model.remark);
      this.$nextTick(() => {
        this.loading = true;
        saveRemark({
          orderId: this.orderId,
          remark: this.$refs[form].model.remark,
        })
          .then((response) => {
            this.loading = false;
            this.$message.success('提交成功');
            statistics(
              Object.assign(
                {
                  event_name: '保存',
                  event_type: 'click',
                  class_name: 'saveRemark',
                  class_url: '/dotadmin/dotadmin/flow/remark/',
                  event_params:
                    '{flowId: this.$route.params.id, remark: this.$refs[form].model.remark}',
                },
                this.staParams,
              ),
            );
          })
          .catch((res) => {
            this.loading = false;
          });
      });
    },

    submitForm(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          let message;
          if (this.orderTag != 4) {
            if (
              this.$refs[form].model.pePrice <=
                this.markingRecommend.recommendPePrice / 3 ||
              this.$refs[form].model.pePrice >=
                this.markingRecommend.recommendPePrice * 3 ||
              (this.slan === 'zh-CN' &&
                this.tlan === 'en' &&
                this.$refs[form].model.pePrice < 10) ||
              (this.tlan === 'zh-CN' &&
                this.slan === 'en' &&
                this.$refs[form].model.pePrice < 14)
            ) {
              if (
                this.slan === 'zh-CN' &&
                this.tlan === 'en' &&
                this.$refs[form].model.pePrice < 10
              ) {
                message =
                  'PE价格设定异常(下限最少是10)，请参考系统建议值进行修改，如坚持下单，此单将流转到风控进行审批';
              } else if (
                this.tlan === 'zh-CN' &&
                this.slan === 'en' &&
                this.$refs[form].model.pePrice < 14
              ) {
                message =
                  'PE价格设定异常(下限最少是14)，请参考系统建议值进行修改，如坚持下单，此单将流转到风控进行审批';
              } else {
                message =
                  'PE价格设定异常(建议价是' +
                  this.markingRecommend.recommendPePrice +
                  ')，请参考系统建议值进行修改，如坚持下单，此单将流转到风控进行审批';
              }
            } else if (
              this.$refs[form].model.peAuditPrice <=
                this.markingRecommend.recommendPeAuditPrice / 3 ||
              this.$refs[form].model.peAuditPrice >=
                this.markingRecommend.recommendPeAuditPrice * 3 ||
              (this.slan === 'zh-CN' &&
                this.tlan === 'en' &&
                this.$refs[form].model.peAuditPrice < 14) ||
              (this.tlan === 'zh-CN' &&
                this.slan === 'en' &&
                this.$refs[form].model.peAuditPrice < 19)
            ) {
              if (
                this.slan === 'zh-CN' &&
                this.tlan === 'en' &&
                this.$refs[form].model.peAuditPrice < 14
              ) {
                message =
                  'PE审核价格设定异常(下限最少是14)，请参考系统建议值进行修改，如坚持下单，此单将流转到风控进行审批';
              } else if (
                this.tlan === 'zh-CN' &&
                this.slan === 'en' &&
                this.$refs[form].model.peAuditPrice < 19
              ) {
                message =
                  'PE审核价格设定异常(下限最少是19)，请参考系统建议值进行修改，如坚持下单，此单将流转到风控进行审批';
              } else {
                message =
                  'PE审核价格设定异常(建议价是' +
                  this.markingRecommend.recommendPeAuditPrice +
                  ')，请参考系统建议值进行修改，如坚持下单，此单将流转到风控进行审批';
              }
            }
          }
          getRecommendTime(
            Object.assign(this.$refs[form].model, {
              flowId: this.orderId,
              orderId: this.orderId,
            }),
          ).then((res) => {
            this.markingRecommend.recommendLimitTime = parseFloat(
              res.data.data,
            );
            if (message) {
              //提示
              this.$alert(message, {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                showCancelButton: true,
                callback: (action) => {
                  if (action === 'confirm') {
                    this.peStart(form, true);
                  }
                },
              });
            } else {
              if (
                this.$refs[form].model.limitTime < parseFloat(res.data.data)
              ) {
                const estTime = formatDate(
                  new Date(parseFloat(res.data.data)),
                  'yyyy-MM-dd hh:mm',
                );
                this.$alert(
                  '此项目系统预估交期将在' +
                    estTime +
                    '结束，当前交期有较大风险，请确认是否下单？如坚持下单，此单将流转到风控进行审批',
                  {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    showCancelButton: true,
                    callback: (action) => {
                      if (action === 'confirm') {
                        this.peStart(form, true);
                      }
                    },
                  },
                );
              } else {
                this.peStart(form, false);
              }
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  },
  computed: {
    ...mapGetters(['permissions']),
    minPeLimit() {
      if (this.orderTag == 4) {
        return 0;
      } else {
        return 0.01;
      }
    },
    minPeAuditLimit() {
      if (this.orderTag == 4) {
        return 0;
      } else {
        return 0.01;
      }
    },
  },
  filters: {},
};
</script>
<style lang="scss" scoped>
.pe-form {
  padding-bottom: 100px;

  .t-note {
    color: #e6a23c;
  }
  .el-form {
    width: 660px;

    .el-input-number,
    .el-select {
      min-width: 180px;
    }
    .p1 {
      font-size: 14px;
      font-weight: bold;
      span {
        font-size: 12px;
        color: #909399;
        padding-left: 10px;
      }
    }
    .input-note {
      font-size: 12px;
      color: #909399;
      margin: 0;
      line-height: 1.5;
    }
    .input-company {
      padding-left: 10px;
      em {
        font-size: 12px;
        color: #909399;
        padding-left: 5px;
      }
    }
  }
}
</style>
